import React from "react";
import GridItem from "../../../../Components//UiComponents/GridItem/GridItem";
import DMSHeader from "../../DMSHeader/DMSHeader";
import { useLocation } from "react-router-dom";
import ContactRegistrationForm from "./ContactRegistrationForm";
import { useTranslation } from "react-i18next";

// Component for creating, editing, or viewing contact details
const CreateContact = () => {
  const { t } = useTranslation(); // Initialize translation hook
  const { state } = useLocation(); // Get navigation state from router
  let edit = state?.edit;
  let view = state?.view;

  // Layout configuration for grid items with header and contact form
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      // Header component with title, download and menu options
      component: (
        <DMSHeader
          title={
            view
              ? t("View Contact Detaiils")
              : edit
              ? t("Edit Contact Detaiils")
              : t("contact_management_formheader") // Dynamic title based on mode (view/edit/create)
          }
          showIconsForback={true}
        />
      ),
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 17,
      id: 2,
      // Main contact form component
      component: <ContactRegistrationForm />,
    },
  ];

  return (
    <div className="grid-stack grid-stack-instance-1 ">
      <GridItem layoutData={layoutData} /> {/* Render grid-based layout */}
    </div>
  );
};

export default CreateContact;
